import { format } from "date-fns";

const timeStampToDateFormat = (timestamp, formatString = "dd/MM/yyyy HH:mm") =>
  !timestamp || isNaN(parseInt(timestamp))
    ? null
    : format(
        new Date(String(timestamp).length > 10 ? timestamp : timestamp * 1000),
        formatString
      );

export default timeStampToDateFormat;
